import React from 'react'

const PresentationContext = React.createContext({
    currentCoverage: {
        loaded: false,
        setLoaded: () => {},
    },
    slider: {
        marginLeft: 0,
        sliderWidth: 0,
        enabled: false,
        domain: [],
        values: [],
        eventSettings: {
            start: null,
            end: null,
        },
        setSliderEnabled: () => {},
        updateDomain: () => {},
        updateValues: () => {},
        updateEventSettings: () => {},
        setMarginLeft: (e) => {},
        setSliderWidth: (e) => {},
    },
})

export default PresentationContext
